import { checkDaysSincePublication } from "./checkDaysSincePublication";

export const compareObjects = (a, b) => {
    const isNewA = checkDaysSincePublication(a.createdTime);
    const isNewB = checkDaysSincePublication(b.createdTime);

    // Porównanie nowości
    if (isNewA && !isNewB) {
        return -1; // A jest nowością
    }
    if (!isNewA && isNewB) {
        return 1; // B jest nowością
    }

    // Jeśli oba są nowościami lub oba nie są, porównujemy poziomy zainteresowania
    const interestA = a.interestLevel || 0; // Domyślnie 0, jeśli brak poziomu zainteresowania
    const interestB = b.interestLevel || 0;

    if (interestA > interestB) {
        return -1; // Wyższy poziom zainteresowania przechodzi na początek
    }
    if (interestA < interestB) {
        return 1; // Niższy poziom zainteresowania przechodzi na koniec
    }

    // Jeśli oba mają takie samo zainteresowanie, porównujemy daty
    const dateA = new Date(a.createdTime).getTime();
    const dateB = new Date(b.createdTime).getTime();

    if (dateA > dateB) {
        return -1; // Nowsza data przechodzi na początek
    }
    if (dateA < dateB) {
        return 1; // Starsza data przechodzi na koniec
    }

    // Jeśli wszystko jest równe, zachowaj oryginalną kolejność
    return 0;
};
